export const rubrosHistoricos = [
    
    {
        "anio" : "2026",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2026/PrimerTrimestre.zip"
            },
        ]
    },
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2025/PrimerTrimestre.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2025/SegundoTrimestre.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2025/TercerTrimestre.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2025/CuartoTrimestre.zip"
            },
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2024/PrimerTrimestre.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2024/SegundoTrimestre.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2024/TercerTrimestre.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2024/CuartoTrimestre.zip"
            },
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2023/PrimerTrimestre.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2023/SegundoTrimestre.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2023/TercerTrimestre.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2023/CuartoTrimestre.zip"
            },
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2022/PrimerTrimestre.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2022/SegundoTrimestre.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2022/TercerTrimestre.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2022/CuartoTrimestre.rar"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2021/PrimerTrimestre.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2021/SegundoTrimestre.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2021/TercerTrimestre.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2021/CuartoTrimestre.rar"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2020/PrimerTrimestre.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2020/SegundoTrimestre.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2020/TercerTrimestre.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2020/CuartoTrimestre.rar"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2019/PrimerTrimestre.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2019/SegundoTrimestre.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2019/TercerTrimestre.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2019/CuartoTrimestre.rar"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/rubros/zip/2018/PrimerTrimestre.rar"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/rubros/zip/2018/SegundoTrimestre.rar"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/rubros/zip/2018/TercerTrimestre.rar"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/rubros/zip/2018/CuartoTrimestre.rar"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.plataformaderubros.org.mx/vut-web/faces/view/consultaPublica.xhtml?idEntidad=MTM=&idSujetoObligado=MjEzMQ==#inicio"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "/rubros/zip/21rubros.rar"
            }
        ]
    }
]